import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    title: {
        flexShrink: 1,
        flexGrow: 1
    }
});
export default stylesheet;
